import React from 'react';
interface TestimonialCardProps {
  initials: string;
  stars: number;
  quote: string;
  name: string;
  location: string;
  level: string;
}
function TestimonialCard({
  initials,
  stars,
  quote,
  name,
  location,
  level
}: TestimonialCardProps) {
  return <>
      <div className="flex items-center gap-3" data-id="element-334">
        <div className="w-12 h-12 rounded-full bg-[#00C853]/20 border border-[#00C853]/40 flex items-center justify-center text-[#00C853] font-black text-sm flex-shrink-0" data-id="element-335">
          {initials}
        </div>
        <div data-id="element-336">
          <div className="text-[#00C853] text-sm" data-id="element-337">{'⭐'.repeat(stars)}</div>
          <div className="text-white font-bold text-sm" data-id="element-338">{name}</div>
          <div className="text-gray-400 text-xs" data-id="element-339">
            📍 {location} | {level}
          </div>
        </div>
      </div>
      <p className="text-gray-300 text-sm leading-relaxed italic" data-id="element-340">
        &quot;{quote}&quot;
      </p>
    </>;
}
export function TestimonialsSection() {
  return <>
      <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-341">
        <div className="max-w-5xl mx-auto" data-id="element-342">
          <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-4" data-id="element-343">
            ❤️ MÁS DOCENTES QUE YA LO TIENEN
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-10" data-id="element-344">
            <TestimonialCard initials="CR" stars={5} quote="El Contenuto Specchio me salvó la vida. Ya no armo dos materiales por clase. Mis alumnos con dislexia por fin participan." name="Cecilia R." location="Mendoza" level="MegaPack + Adaptaciones" data-id="element-345" />
            <TestimonialCard initials="RM" stars={5} quote="Con el roleplay del bar, en 10 minutos el grupo entero estaba hablando italiano sin vergüenza." name="Roberto M." location="Buenos Aires" level="Docente de Italiano" data-id="element-346" />
            <TestimonialCard initials="SC" stars={5} quote="Mis alumnos de A1 terminaron el nivel hablando italiano. Eso no pasaba nunca." name="Sofía C." location="La Plata" level="Docente de Italiano" data-id="element-347" />
            <TestimonialCard initials="PA" stars={5} quote="El Framework de 20 segundos para corregir sin interrumpir el flujo de la clase fue un antes y un después." name="Pablo A." location="Neuquén" level="Docente de Italiano" data-id="element-348" />
          </div>
        </div>
      </section>
    </>;
}